export const defaultImg = 'https://static.szlcsc.com/ecp/assets/newWeb/item/default_pic.gif';

export const noGoodsDefaultImg = 'https://static.szlcsc.com/ecp/assets/web/static/images/no_goods_pic_big.png';

const tiPic = 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/ti.png';

export const lcBookProvider = ['ti', 'te', 'waldom', 'rochester'];

export const sameImgNameList = [
  { name: 'lcdh', code: 'ti', format: 'jpg' },
  { name: 'lcdh', code: 'waldom', format: 'jpg' },
  { name: 'lcdh', code: 'rochester', format: 'jpg' },
  { name: 'lcdh', code: 'te', format: 'jpg' },
  { name: 'ti_new', code: 'ti_ovs', format: 'png' },
  { name: 'burklin', code: 'burklin', format: 'png' },
  { name: 'digikey', code: 'digikey', format: 'jpg' },
  {
    name: 'arrow_new',
    code: 'arrow',
    format: 'png',
    src: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/a.png',
  },
  { name: 'mouser', code: 'mouser', format: 'jpg' },
  {
    name: 'element',
    code: 'element',
    format: 'png',
    src: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/e.png',
  },
  {
    name: 'element14_uk',
    code: 'element14_uk',
    format: 'png',
    src: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/e.png',
  },
  { name: 'ti', code: 'future', format: 'png', src: tiPic },
  {
    name: 'verical_new',
    code: 'verical',
    format: 'png',
    src: 'https://static.szlcsc.com/ecp/assets/web/page/so/so/images/v.png',
  },
  { name: 'avnet', code: 'avnet_us', format: 'jpg' },
  { name: 'avnet', code: 'avnet_eur', format: 'jpg' },
  { name: 'avnet', code: 'avnet_asia', format: 'jpg' },
  { name: 'OLC', code: 'onlinecomponents', format: 'jpg' },
  { name: 'RS', code: 'rscomponents', format: 'jpg' },
  { name: 'ti', code: 'tme', format: 'png', src: tiPic },
  { name: 'corestaff', code: 'corestaff', format: 'jpg' },
  { name: 'tti', code: 'tti', format: 'png' },
  { name: 'rutronik', code: 'rutronik', format: 'jpg' },
  { name: 'questcomp', code: 'questcomp', format: 'jpg' },
  { name: 'powell', code: 'powell', format: 'jpg' },
  { name: 'sager', code: 'sager', format: 'jpg' },
  { name: 'chip1stop', code: 'chip1stop', format: 'jpg' },
  { name: 'heilind', code: 'heilind', format: 'jpg' },
];
